import type { BannerText } from '../../../lib/api';

/**
 * The banner script's own wording per language, shown as placeholders so an
 * editor sees what the visitor gets when a field is left blank. Copied from
 * packages/widget/src/cookies.js (STRINGS); a language the script does not
 * carry shows "Standard wording".
 */
export const PACK_DEFAULTS: Record<string, BannerText> = {
  en: {
    title: 'Cookies on this site',
    body: 'Essential cookies run the site. Others need your permission, and you can change your mind at any time.',
    accept: 'Accept all',
    reject: 'Reject all',
    customise: 'Customise',
    noticeLink: 'Read the full notice',
    reopen: 'Cookie settings'
  },
  hi: {
    title: 'इस साइट पर कुकीज़',
    body: 'आवश्यक कुकीज़ साइट चलाती हैं। बाकी के लिए आपकी अनुमति चाहिए, और आप कभी भी अपना मन बदल सकते हैं।',
    accept: 'सभी स्वीकार करें',
    reject: 'सभी अस्वीकार करें',
    customise: 'अनुकूलित करें',
    noticeLink: 'पूरी सूचना पढ़ें',
    reopen: 'कुकी सेटिंग्स'
  },
  mr: {
    title: 'या साइटवरील कुकीज',
    body: 'आवश्यक कुकीज साइट चालवतात. इतर कुकीजसाठी तुमची परवानगी लागते, आणि तुम्ही केव्हाही तुमचा निर्णय बदलू शकता.',
    accept: 'सर्व स्वीकारा',
    reject: 'सर्व नाकारा',
    customise: 'सानुकूलित करा',
    noticeLink: 'संपूर्ण सूचना वाचा',
    reopen: 'कुकी सेटिंग्ज'
  },
  gu: {
    title: 'આ સાઇટ પરની કૂકીઝ',
    body: 'આવશ્યક કૂકીઝ સાઇટ ચલાવે છે. અન્ય માટે તમારી મંજૂરી જરૂરી છે, અને તમે ગમે ત્યારે તમારો નિર્ણય બદલી શકો છો.',
    accept: 'બધી સ્વીકારો',
    reject: 'બધી નકારો',
    customise: 'કસ્ટમાઇઝ કરો',
    noticeLink: 'સંપૂર્ણ સૂચના વાંચો',
    reopen: 'કૂકી સેટિંગ્સ'
  },
  ta: {
    title: 'இந்தத் தளத்தில் உள்ள குக்கீகள்',
    body: 'அத்தியாவசியக் குக்கீகள் தளத்தை இயக்குகின்றன. மற்றவற்றுக்கு உங்கள் அனுமதி தேவை, உங்கள் முடிவை எப்போது வேண்டுமானாலும் மாற்றலாம்.',
    accept: 'அனைத்தையும் ஏற்கவும்',
    reject: 'அனைத்தையும் நிராகரிக்கவும்',
    customise: 'தனிப்பயனாக்கவும்',
    noticeLink: 'முழு அறிவிப்பையும் படிக்கவும்',
    reopen: 'குக்கீ அமைப்புகள்'
  },
  te: {
    title: 'ఈ సైట్‌లోని కుకీలు',
    body: 'అవసరమైన కుకీలు సైట్‌ను నడుపుతాయి. ఇతర కుకీలకు మీ అనుమతి అవసరం, మీరు ఎప్పుడైనా మీ నిర్ణయం మార్చుకోవచ్చు.',
    accept: 'అన్నింటినీ ఆమోదించండి',
    reject: 'అన్నింటినీ తిరస్కరించండి',
    customise: 'అనుకూలీకరించండి',
    noticeLink: 'పూర్తి నోటీసును చదవండి',
    reopen: 'కుకీ సెట్టింగ్‌లు'
  },
  bn: {
    title: 'এই সাইটের কুকিজ',
    body: 'প্রয়োজনীয় কুকিজ সাইটটি চালায়। অন্যগুলির জন্য আপনার অনুমতি প্রয়োজন, এবং আপনি যেকোনো সময় আপনার সিদ্ধান্ত বদলাতে পারেন।',
    accept: 'সব গ্রহণ করুন',
    reject: 'সব প্রত্যাখ্যান করুন',
    customise: 'কাস্টমাইজ করুন',
    noticeLink: 'সম্পূর্ণ বিজ্ঞপ্তি পড়ুন',
    reopen: 'কুকি সেটিংস'
  },
  kn: {
    title: 'ಈ ಸೈಟ್‌ನಲ್ಲಿನ ಕುಕೀಗಳು',
    body: 'ಅಗತ್ಯ ಕುಕೀಗಳು ಸೈಟ್ ಅನ್ನು ನಡೆಸುತ್ತವೆ. ಇತರವುಗಳಿಗೆ ನಿಮ್ಮ ಅನುಮತಿ ಬೇಕು, ಮತ್ತು ನೀವು ಯಾವಾಗ ಬೇಕಾದರೂ ನಿಮ್ಮ ನಿರ್ಧಾರವನ್ನು ಬದಲಾಯಿಸಬಹುದು.',
    accept: 'ಎಲ್ಲವನ್ನೂ ಸ್ವೀಕರಿಸಿ',
    reject: 'ಎಲ್ಲವನ್ನೂ ತಿರಸ್ಕರಿಸಿ',
    customise: 'ಕಸ್ಟಮೈಸ್ ಮಾಡಿ',
    noticeLink: 'ಪೂರ್ಣ ಸೂಚನೆಯನ್ನು ಓದಿ',
    reopen: 'ಕುಕೀ ಸೆಟ್ಟಿಂಗ್‌ಗಳು'
  },
  ml: {
    title: 'ഈ സൈറ്റിലെ കുക്കികൾ',
    body: 'അത്യാവശ്യ കുക്കികൾ സൈറ്റ് പ്രവർത്തിപ്പിക്കുന്നു. മറ്റുള്ളവയ്ക്ക് നിങ്ങളുടെ അനുമതി വേണം, നിങ്ങൾക്ക് എപ്പോൾ വേണമെങ്കിലും തീരുമാനം മാറ്റാം.',
    accept: 'എല്ലാം സ്വീകരിക്കുക',
    reject: 'എല്ലാം നിരസിക്കുക',
    customise: 'ഇഷ്ടാനുസൃതമാക്കുക',
    noticeLink: 'പൂർണ്ണ അറിയിപ്പ് വായിക്കുക',
    reopen: 'കുക്കി ക്രമീകരണങ്ങൾ'
  }
};
